import React, { Component } from "react";
import ScrollToTop from 'react-scroll-up';
import { FiChevronUp } from "react-icons/fi";

import PageHelmet from "../../components/Helmet";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import Banner from "../../components/Banner";
import LoglineAndSynopsis from "../../components/LoglineAndSynopsis";
import Summary from "../../components/Summary";

function WritingPageNew(props) {
    return class PortfolioDetails extends Component {
        constructor () {
            super()
            this.state = {
              isOpen: false
            }
            this.openModal = this.openModal.bind(this)
        }
        openModal () {
            this.setState({isOpen: true})
        }
        render(){
            return(
                <React.Fragment>
                    
                    <PageHelmet pageTitle='Portfolio Details' />

                    <Header logo="symbol-dark" color="color-black"/>
                    
                    <Banner title={props.title} type={props.type} bg={props.bg} />

                    <Summary summary={props.summary} type={props.type}title={props.title}/>

                    {/* Start Back To Top */}
                    <div className="backto-top">
                        <ScrollToTop showUnder={160}>
                            <FiChevronUp />
                        </ScrollToTop>
                    </div>
                    {/* End Back To Top */}
                    
                    <Footer />  


                </React.Fragment>
            )
        }
    }
}

export default WritingPageNew;
